import React, { useState, useEffect } from 'react';

import {
    Checkbox,
    FormHelp,
    Label,
    LabeledControl,
    Radio,
    Select,
    Spacer,
} from '@zillow/constellation';

const brokerLicenseTypes = [
    {
        apiKey: 'RealEstateSalesPerson',
        type: 'Real Estate Sales Person',
    },
    {
        apiKey: 'RealEstateBroker',
        type: 'Real Estate Broker',
    },
    {
        apiKey: 'AssociateRealEstateBroker',
        type: 'Associate Real Estate Broker',
    },
];

const rentByOptions = [
    {
        id: 'property-owner',
        label: 'Property owner',
        formDataKey: 'owner',
    },
    {
        id: 'broker',
        label: 'Management company or broker',
        formDataKey: 'agent',
    },
    {
        id: 'tenant',
        label: 'Tenant',
        formDataKey: 'tenant',
    },
];

const ForRentBy = ({
    formData: {
        forRentBy,
        isListingExclusive,
        agentLicenseType,
        restrictions: { isUpdateAgentRestricted },
    },
    immediateUpdateAndSave,
    errorObj,
    updateFormData,
}) => {
    const [isForRentByBroker, setIsForRentByBroker] = useState();

    useEffect(() => {
        if (forRentBy === 'agent') {
            setIsForRentByBroker(true);
        } else {
            setIsForRentByBroker(false);
            updateFormData({
                isListingExclusive: false,
                agentLicenseType: null,
            });
        }
    }, [isListingExclusive, agentLicenseType, forRentBy]);

    const handleOnChange = (forRentByType) => {
        if (forRentByType === 'agent') {
            setIsForRentByBroker(true);
        }
        immediateUpdateAndSave('forRentBy', forRentByType);
    };

    return (
        <div className="forRentBy">
            <Label required={true}>For rent by</Label>
            {rentByOptions.map(option => (
                <LabeledControl
                    key={`contact-${option.id}`}
                    controlId={`LabeledControl-contact-${option.id}`}
                    data-test={`contact-${option.id}`}
                    label={<Label>{option.label}</Label>}
                    control={(
                        <Radio
                            name="LabeledControl-contact"
                            checked={forRentBy === option.formDataKey}
                            onChange={() => handleOnChange(option.formDataKey)}
                        />
                    )}
                />
            ))}
            {errorObj.forRentBy && <FormHelp error={true}>{errorObj.forRentBy}</FormHelp>}
            {isForRentByBroker && !isUpdateAgentRestricted && (
                <Spacer marginY="sm">
                    <Label>Additional broker information</Label>
                    <Spacer marginY="xs">
                        <LabeledControl
                            controlId="LabeledControl-exclusive-listing"
                            label={<Label>Listing is exclusive</Label>}
                            control={(
                                <Checkbox
                                    name="LabeledControl-exclusive-listing"
                                    onChange={() => immediateUpdateAndSave('isListingExclusive', !isListingExclusive)}
                                    checked={isListingExclusive}
                                />
                            )}
                        />
                    </Spacer>
                    <Label>License type</Label>
                    <Spacer marginY="xs">
                        <Select
                            value={agentLicenseType}
                            size="sm"
                            onChange={({ target: { value } }) => {
                                const licenseType = value === '' ? null : value;
                                immediateUpdateAndSave('agentLicenseType', licenseType);
                            }}
                        >
                            <option value={null} key="no-value" />
                            {brokerLicenseTypes.map(license => (
                                <option key={license.apiKey} value={license.apiKey}>{license.type}</option>
                            ))}
                        </Select>
                    </Spacer>
                    {(errorObj.agentLicenseType || errorObj.isListingExclusive) && (
                        <FormHelp error={true}>
                            There was an error saving your broker information. Please try again.
                        </FormHelp>
                    )}
                </Spacer>
            )}
        </div>
    );
};

export { ForRentBy };
